import { render } from "./HomeOrComponentMix.vue?vue&type=template&id=4ea2f9de&ts=true"
import script from "./HomeOrComponentMix.vue?vue&type=script&lang=ts"
export * from "./HomeOrComponentMix.vue?vue&type=script&lang=ts"

import "./HomeOrComponentMix.vue?vue&type=style&index=0&id=4ea2f9de&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__